import { MailTemplate } from '@/interfaces/mailTemplate';
import { EntityResource } from './entity.resource';
import { FilterArgs, FilterVariables } from './queryVariables/filters/filters';

/**
 * Resource szablonów wiadomości e-mail
 *
 * @export
 * @class MailTemplateResource
 * @extends {EntityResource<MailTemplate>}
 */
export class MailTemplateResource extends EntityResource<MailTemplate> {
  public getFields = {
    id: true,
    name: true,
    subject: true,
    fromName: true,
    fromAddress: true,
    to: true,
    body: true
  };

  public listFields = {
    id: true,
    name: true
  };

  protected listVariables = FilterVariables;
  protected listArgs = FilterArgs;

  constructor() {
    super({
      entityName: 'mailTemplate'
    });
  }
}

export const mailTemplateResource = new MailTemplateResource();
